import { useState, useEffect } from 'react';

const ReadingProgress = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const calculateReadingProgress = () => {
      const article = document.querySelector('article');
      if (!article) return;

      const articleTop = article.offsetTop;
      const articleHeight = article.offsetHeight;
      const windowHeight = window.innerHeight;
      const scrollTop = window.scrollY;

      // Calculate how much of the article has been scrolled through
      const startReading = articleTop - windowHeight / 2;
      const finishReading = articleTop + articleHeight - windowHeight / 2;
      
      if (scrollTop < startReading) {
        setProgress(0);
      } else if (scrollTop > finishReading) {
        setProgress(100);
      } else {
        const currentProgress = ((scrollTop - startReading) / (finishReading - startReading)) * 100;
        setProgress(Math.min(100, Math.max(0, currentProgress)));
      }
    };

    // Calculate on mount
    calculateReadingProgress();

    // Add scroll listener
    window.addEventListener('scroll', calculateReadingProgress);
    window.addEventListener('resize', calculateReadingProgress);

    return () => {
      window.removeEventListener('scroll', calculateReadingProgress);
      window.removeEventListener('resize', calculateReadingProgress);
    };
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-1 bg-muted z-50">
      <div 
        className="h-full bg-primary transition-all duration-150 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default ReadingProgress;